import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Qq = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.005 13.018c-.779-.547-1.751-.51-2.304.277-.553.785-4.418 5.633-10.751 3.619.239.209.49.406.755.592 4.153 2.926 9.892 1.928 12.816-2.225.555-.787.263-1.714-.516-2.263zm-12.22-.617c-.404-.871-2.669-6.643 2.24-11.121a9.2 9.2 0 00-5.371 12.57c.403.871 1.353 1.084 2.218.684.864-.401 1.316-1.262.913-2.133zM10.826.823c-.956-.086-1.614.629-1.7 1.578-.085.949.435 1.771 1.391 1.857.956.086 7.087 1.01 8.51 7.502.062-.311.106-.627.136-.949.455-5.061-3.277-9.533-8.337-9.988zM6.891 10.53c-.264.619-.306 1.213-.094 1.322.146.076.374-.098.588-.416.085.347.295.662.595.914-.314.115-.52.305-.52.519 0 .354.556.639 1.241.639.618 0 1.13-.232 1.225-.537h.147c.095.305.607.537 1.226.537.686 0 1.241-.285 1.241-.639 0-.215-.205-.404-.52-.519.299-.252.51-.566.594-.914.214.318.442.492.589.416.211-.109.17-.703-.095-1.322-.207-.488-.488-.848-.702-.926.004-.031.004-.063.004-.094a.933.933 0 00-.142-.504c.002-.012.002-.023.002-.033a.528.528 0 00-.056-.238C12.16 7.467 11.335 6.461 10 6.461c-1.336 0-2.161 1.006-2.215 2.273a.529.529 0 00-.057.238l.002.033a.958.958 0 00-.137.599c-.213.078-.495.437-.702.926z"
  }));
});
Qq.displayName = 'Qq';
export var QqDimensions = {
  height: 20,
  width: 20
};